import { LOCALE_ID, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { BrowserModule } from '@angular/platform-browser';
import { AppAdminImportsRoutingModule } from './app-routing.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { CoreFeatureNotificationModule } from '@nx-ratenow/core/feature-notifications';
import { MtxNativeDatetimeModule } from '@ng-matero/extensions/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreLayoutFeatureCustomLayoutModule } from '@nx-ratenow/core/layout/feature-custom-layout';

import {
  HttpConfigInterceptor,
  HttpErrorInterceptor,
  RetryInterceptor,
  LanguageInterceptor,
  JwtInterceptor
} from '@nx-ratenow/core/interceptors';

// STORE
import { StoreModule } from '@ngrx/store';
import { routerReducer } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import * as fromUserStore from '@nx-ratenow/core/data-access-user';
import {
  NOTIFICATIONS_FEATURE_KEY,
  NotificationsEffects,
  initialStateNotifications,
  notificationsReducer
} from '@nx-ratenow/core/layout/feature-toolbar';
import {
  SENDINGS_FEATURE_KEY,
  SendingsEffects,
  initialSendingsState,
  sendingsReducer
} from '@nx-ratenow/shared/feature-sendings-details';
import { DataAccessNavigationImportsModule } from '@nx-ratenow/core/data-access-navigation-imports';
import * as fromStepper from '@nx-ratenow/shared/feature-stepper';
import { AplicationTypeName } from '@nx-ratenow/shared/enums';
import { APP_TYPE } from '@nx-ratenow/core/config';

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppAdminImportsRoutingModule,

    MatDatepickerModule,
    MatNativeDateModule,

    CoreFeatureNotificationModule,
    MtxNativeDatetimeModule,

    BrowserModule,

    HttpClientModule,
    BrowserAnimationsModule,

    CoreLayoutFeatureCustomLayoutModule,

    // STORE

    StoreModule.forRoot(
      {
        router: routerReducer
      },
      {
        runtimeChecks: {
          strictStateImmutability: true,
          strictActionImmutability: true,
          strictStateSerializability: false,
          strictActionSerializability: false
        }
      }
    ),
    StoreDevtoolsModule.instrument(),
    EffectsModule.forRoot([]),

    // AUTH - USER

    StoreModule.forFeature(
      fromUserStore.AUTH_FEATURE_KEY,
      fromUserStore.reducer,
      {
        metaReducers: [fromUserStore.localStorageSyncReducer],
        initialState: fromUserStore.initialState
      }
    ),

    EffectsModule.forFeature([fromUserStore.AuthEffects]),

    // STEPPER STORE

    StoreModule.forFeature(
      fromStepper.STEPPER_FEATURE_KEY,
      fromStepper.reducer,
      {
        initialState: fromStepper.initialState
      }
    ),

    // NAVIGATION

    DataAccessNavigationImportsModule,

    // SENDINGS
    StoreModule.forFeature(SENDINGS_FEATURE_KEY, sendingsReducer, {
      initialState: initialSendingsState
    }),
    EffectsModule.forFeature([SendingsEffects]),

    // NOTIFICATIONS

    StoreModule.forFeature(NOTIFICATIONS_FEATURE_KEY, notificationsReducer, {
      initialState: initialStateNotifications
    }),
    EffectsModule.forFeature([NotificationsEffects])
  ],
  providers: [
    MatDatepickerModule,
    {
      provide: LOCALE_ID,
      useValue: 'es'
    },
    {
      provide: APP_TYPE,
      useValue: AplicationTypeName.imports
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LanguageInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RetryInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
